export default function Status404() {
  return (
    <center className="relative flex flex-col text-white justify-center items-center h-224 font-semibold">
      <div className="text-4xl font-bold z-10">404: Page Not Found</div>
      <div className="text-xl pt-4 z-10">Sorry, the page you are looking for does not exist.</div>
      <div className="absolute top-0 right-0 w-full h-full bg-castell bg-opacity-80" />
    </center>
  );
}
